<template>
<v-container fluid fill-height>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else>
        <v-flex xs12>
            <v-card>
                <v-toolbar color="primary" class="white--text">
                    <v-toolbar-title>Scouting Crop Stages</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon dark large>timeline</v-icon>
                </v-toolbar>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-alert :value="error != null" outline type="error">
                            {{error}}
                        </v-alert>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn color="primary" block @click="showEditAddScoutingCropStage({ IsActive: true })">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout pt-3>
                    <v-flex xs12>
                        <scouting-crop-stage-table :search="search" :filteredItems="filteredItems" @edit="showEditAddScoutingCropStage($event)"></scouting-crop-stage-table>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog 
            :value="editing"
            fullscreen 
            hide-overlay 
            transition="dialog-bottom-transition">
            <scouting-crop-stage-edit 
                v-if="editing"
                :item="editItem"                
                :submitLoading="loading"
                :submitError="error"
                @submit="handleSubmit"
                @cancel="cancelEdit()">
            </scouting-crop-stage-edit>
        </v-dialog>
</v-container>
</template>

<script>
import ScoutingCropStageTable from "@/components/configuration/scoutingCropStages/ScoutingCropStageTable.vue";
import ScoutingCropStageEdit from "@/components/configuration/scoutingCropStages/ScoutingCropStageEdit.vue";

import scoutApi from '@/api/scoutApi'

export default {
    components: {
        ScoutingCropStageTable: ScoutingCropStageTable,
        ScoutingCropStageEdit: ScoutingCropStageEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            loading: false,
            search: "",
            activeOnly: true,
            editItem: null,
            scoutingCropStages: []
        }
    },
    computed: {
        filteredItems() {
            return this.scoutingCropStages.filter(c => c.IsActive === this.activeOnly || !this.activeOnly);
        }
    },
    methods: {
        async loadScoutingCropStages() {
            this.loading = true;
            this.error = null;

            try {
                this.scoutingCropStages = await scoutApi.getScoutingCropStages();

            } catch (err) {
                this.error = err;
            }

            this.loading = false;
        },
        showEditAddScoutingCropStage(item) {            
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            if (this.scoutingCropStages.filter(a => a.Name.trim() === item.Name.trim() && a.ScoutingCropStageID !== item.ScoutingCropStageID).length > 0) {
                this.error = "Scouting Crop Stage with the same name already exists."
                return;
            }

            this.loading = true;

            try {
                let response = {};

                if (item.ScoutingCropStageID > 0) {
                    response = await scoutApi.updateScoutingCropStage(item);                    
                } else {                    
                    response = await scoutApi.addScoutingCropStage(item);                    
                }                

                if (!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }

                this.editing = false;
            } catch (err) {
                this.error = err;
                return;

            } finally {
                this.loading = false;
            }

            await this.loadScoutingCropStages();
        }
    },
    async created() {
        await this.loadScoutingCropStages();
    }
}
</script>
